/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Guide_How_It_Works_TitleInputs */

const en_directory_guide_how_it_works_title = /** @type {(inputs: Directory_Guide_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From submission to a managed listing`)
};

const zh_directory_guide_how_it_works_title = /** @type {(inputs: Directory_Guide_How_It_Works_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从提交到可管理的产品页面`)
};

/**
* | output |
* | --- |
* | "From submission to a managed listing" |
*
* @param {Directory_Guide_How_It_Works_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_guide_how_it_works_title = /** @type {((inputs?: Directory_Guide_How_It_Works_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Guide_How_It_Works_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_guide_how_it_works_title(inputs)
	return zh_directory_guide_how_it_works_title(inputs)
});
export { directory_guide_how_it_works_title as "directory.guide.how_it_works.title" }